export * from './crud.service';
export * from './crud.repository';
export * from './crud.controller';
export * from './crud-get-all-dto';
export * from './crud-endpoints';
